module.exports = __webpack_public_path__ + "static/media/new_back_arrow.a54a5923.svg";